module.exports = __webpack_public_path__ + "media/src/images/icons/file_types/png-2f0c6ec64c6169bd967dd9752798b61e.svg";